module.exports = __webpack_public_path__ + "img/加油.6d773329.png";